module.exports = {
  QuickSearchAdNumber: 'Quick Search: Ad Number',
  Remove: 'Remove',
  Publish: 'Publish',
  AdNumber: 'Ad Number',
  SubjectName: 'Subject/Name',
  AdContent: 'Ad Content',
  Advertiser: 'Advertiser',
  AdPosition: 'Ad Position',
  BelongToPage: 'Belong to Page',
  BelongToModule: 'Belong to Module',
  BelongToSystem: 'Belong to System',
  Status: 'Status',
  TargetAudience: 'Target Audience',
  Global: 'Global',
  Creator: '作成者',
  CreationDate: 'Creation Date',
  Modifier: 'Modifier',
  ModificationDate: 'Modification Date',
  PromotionPeriod: 'Promotion Period',
  EffectiveTime: 'Effective Time',
  ExpirationTime: 'Expiration Time',
  PleaseCheckOneEntry: 'Please check one entry!',
  ContainsUnremovedData: 'Contains unremoved data!',
  AreYouWantToDelete: 'Are you sure you want to delete?',
  PleaseSelectOneEntry: 'Please select one entry!',
  PleaseOnlySelectOneRecord: 'Please only select one record!',
  ContainsAlreadyRemovedData: 'Contains already removed data!',
  AreYouWantToRemove: 'Are you sure you want to remove?',
  AreYouWantToPublish: 'Are you sure you want to publish?',
  ThePositionHasBeenDisabled: 'The ad position has been disabled!',
  TheReachedTheMaximumPlacements: 'The ad position has reached the maximum number of placements!',
  RemainingAreNotEnoughCheck: 'Remaining ad positions are not enough, please check!',
  ContainsPublishedOrExpiredData: 'Contains already published or expired data!',
  View: 'View',
  Edit: 'Edit',
  Enable: 'Enable',
  Disable: 'Disable',
  AdPositionNumber: 'Ad Position Number',
  CurrentlyPlacedAdCount: 'Currently placed ad count',
  MaximumSupportedAdCount: 'Maximum supported ad count',
  CurrentDisabledAndCannotEdited: 'Current data is not disabled and cannot be edited!',
  AreYouWantToDisable: 'Are you sure you want to disable?',
  AreYouWantToDisable2: 'Are you sure you want to disable?',
  ContainsNonDisabledData: 'Contains non-disabled data!',
  AreYouWantToEnable: 'Are you sure you want to enable?',
  TemplateManagement: 'Template Management',
  TemplateTypeManagement: 'Template Type Management',
  ConfigurationManagement: 'Configuration Management',
  MappingManagement: 'Mapping Management',
  InitializeTemplateManagement: 'Initialize Template Management',
  BusinessStatusManagement: 'Business Status Management',
  TriggerTypeManagement: 'Trigger Type Management',
  FileTypeManagement: 'File Type Management',
  DefaultValueManagement: 'Default Value Management',
  ValidationRuleConfiguration: 'Validation Rule Configuration',
  EDITemplateSetting: 'EDI Template Setting',
  SeaFreightOnlineCheckingSettings: 'Sea Freight Online Checking Settings',
  ShippingRouteAndWarehouseConfiguration: 'Shipping Route and Warehouse Configuration',
  PushServiceConfiguration: 'Push Service Configuration',
  InvoiceCustomRemark: 'Invoice Custom Remark',
  CustomRemarkOne: 'カスタムメモ1',
  CustomRemarkTwo: 'カスタムメモ2',
  EmailTemplateManagement: 'Email Template Management',
  ReleaseConfiguration: 'Release Configuration',
  PromotionTimeRange: 'Promotion Time Range',
  JumpLink: 'Jump Link',
  Cancel: 'Cancel',
  Save: 'Save',
  Return: 'Return',
  Homepage: 'Homepage',
  SelectAll: 'Select All',
  DeselectAll: 'Deselect All',
  AreYouWantToCancel: 'Are you sure you want to cancel?',
  NumberOfClickedUsers: 'Number of Clicked Users',
  BelongToCompany: 'Belong to Company',
  UserType: 'User Type',
  Username: 'Username',
  PlatformCustomerService: 'Platform Customer Service',
  ClickTime: 'Click Time',
  BrowsingTime: 'Browsing Time',
  StartTime: 'Start Time:',
  EndTime: 'End Time:',
  SequenceNumber: 'Sequence Number',
  Code: 'Code',
  ChineseName: 'Chinese Name',
  EnglishName: 'English Name',
  NodeType: 'Node Type',
  Remarks: '備考',
  CreateStatus: 'Create Status',
  Delete: 'Delete',
  IsItPublic: 'Is it public',
  CreateStatusDetail: 'Create Status Detail',
  EditStatus: 'Edit Status',
  DeleteSuccessful: 'Delete Successful',
  SaveSuccessful: 'Save Successful',
  PleaseEnterCode: 'Please enter code',
  PleaseEnterNodeType: 'Please enter node type',
  PleaseEnterCodeChineseName: 'Please enter code Chinese name',
  PleaseEnterCodeEnglishName: 'Please enter code English name',
  StatusType: 'Status Type',
  ExternalCode: 'External Code',
  Name: 'Name',
  GenerateElectronicFile: 'Generate Electronic File',
  FileType: 'File Type',
  DataService: 'Data Service',
  ReportTemplate: 'Report Template',
  PushObject: 'Push Object',
  PushChannel: 'Push Channel',
  SubjectTemplate: 'Subject Template',
  BodyTemplate: 'Body Template',
  DataItem: 'Data Item',
  AttachmentFileType: 'Attachment File Type',
  TemplateSubject: 'Template Subject',
  TemplateContent: 'Template Content',
  TemplateExample: 'Template Example',
  SendTest: 'Send Test',
  ConfigureSOPMessagePush: 'Configure SOP Message Push',
  EditStatusDetail: 'Edit Status Detail',
  InitialStatus: 'Initial Status',
  AutoTrigger: 'Auto Trigger',
  StatusChangeNotification: 'Status Change Notification',
  SendNotification: 'Send Notification',
  NoNotification: 'No Notification',
  DesignatedPosition: 'Designated Position',
  Sales: ' 売上',
  Operation: ' 操作内容',
  CustomerService: 'カスタマーサービス',
  OverseasCustomerService: 'Overseas Customer Service',
  Documentation: 'Documentation',
  ShippingLineManager: 'Shipping Line Manager',
  DesignatedPersonnel: 'Designated Personnel',
  Email: 'Email',
  SopPushLog: 'sop push log',
  Confirm: 'Confirm',
  SendTo: 'Send to:',
  Note: 'Note',
  WillBusinessDetailsAndNodes: 'Will delete associated business details and SOP nodes',
  PleaseEnterContent: 'Please enter content',
  NotStarted: 'Not started',
  InProgress: 'In progress',
  Completed: 'Completed',
  Abnormal: 'Abnormal',
  BookingSuccessful: 'Booking successful',
  WarehouseEntryNotice: 'Warehouse entry notice',
  CustomsClearance: 'Customs clearance',
  SailingNotice: 'Sailing notice',
  IssuanceOfBillOfLading: 'Issuance of bill of lading',
  Customer: 'Customer',
  DestinationPortAgent: 'Destination port agent',
  DesignatedFreightForwarder: 'Designated freight forwarder',
  DeparturePortAgent: 'Departure port agent',
  DesignatedPositionsAndPersonnel: 'Designated positions and personnel',
  PleaseEnterTheCode: 'Please enter the code',
  PleaseEnterTheChineseName: 'Please enter the Chinese name',
  ChineseNameLengthExceeded20: 'Chinese name length exceeded 20!',
  PleaseEnterTheEnglishName: 'Please enter the English name',
  PleaseSelectTheStatusType: 'Please select the status type!',
  PleaseSelectTheTriggerType: 'Please select the trigger type',
  PleaseSelectTheStatusType2: 'Please select the status type',
  TheAlreadyExistsPleaseEnter: 'The same code already exists, please re-enter!',
  TheAlreadyExistsPleaseEnter2: 'The same Chinese name already exists, please re-enter!',
  TheAlreadyExistsPleaseEnter3: 'The same English name already exists, please re-enter!',
  SaveSuccess: 'Save success',
  DeleteSuccess: 'Delete success',
  BusinessDetailsDoNotExist: 'Business details do not exist',
  PleaseEnterTheSubjectTemplate: 'Please enter the subject template',
  PleaseTheTextTemplateContent: 'Please enter the text template content',
  PleaseEnterTheTemplateContent: 'Please enter the template content',
  PleaseEnterTheTemplateExample: 'Please enter the template example',
  PleaseFirstSelectData: 'Please first select data',
  AreWantToDeleteRecord: 'Are you sure you want to delete the selected record?',
  Tips: 'Tips',
  PleaseTheTestEmailAddress: 'Please enter the test email address!',
  EmailFormatError: 'Email format error!',
  EmailCannotExceed128Characters: 'Email length cannot exceed 128 characters',
  PleaseTestMobilePhoneNumber: 'Please enter the test mobile phone number!',
  MobileCanOnlyBeNumbers: 'Mobile phone number can only be valid numbers!',
  MobilePhoneNumberFormatError: 'Mobile phone number format error!',
  SendSuccess: 'Send success!',
  SendFailure: 'Send failure!',
  APIOutputAdditionalInformation: 'API output additional information',
  OutputDescription: 'Output description',
  OutputIdentification: 'Output identification',
  DataSource: 'Data source',
  DataField: 'Data field',
  WarningSwitch: 'Warning switch',
  SailingTimeETD: 'Sailing time (ETD)',
  ArrivalTimeETA: 'Arrival time (ETA)',
  OpenPortTime: 'Open port time',
  ClosingPortTime: 'Closing port time',
  ClosingTimeForOrders: 'Closing time for orders',
  CustomsClosingTime: 'Customs closing time',
  ScheduledBerthingDate: 'Scheduled berthing date',
  ScheduledDepartureDate: 'Scheduled departure date',
  WarningTime: 'Warning time',
  Advance: 'Advance',
  Delay: 'Delay',
  WarningSettings: 'Warning settings',
  TurnOnWarning: 'Turn on warning',
  TurnOffWarning: 'Turn off warning',
  HoursWarningReminder: 'Hours, warning reminder',
  Highest: 'Highest',
  High: 'High',
  Medium: 'Medium',
  Low: 'Low',
  Relation: 'Relation',
  FilterValue: 'Filter value',
  ValidationCondition: 'Validation condition',
  New: 'New',
  And: 'And',
  Or: 'Or',
  FilterBasis: 'Filter basis',
  CurrentlyModeUnableToNew: 'Currently in edit mode, unable to create new',
  CurrentlyModeUnableToDelete: 'Currently in edit mode, unable to delete',
  PleaseSelectAFilterBasis: 'Please select a filter basis',
  PleaseSelectTheFilterValue: 'Please select the filter value',
  ValidationExpression: 'Validation expression',
  PositiveOperation: 'Positive operation',
  PreSubmit: 'Pre-submit',
  Submitted: 'Submitted',
  Reviewed: 'Reviewed',
  ValidationItem: 'Validation item',
  Empty: 'Empty',
  PleaseSelectValidationItem: 'Please select validation item',
  RuleName: 'Rule name',
  ValidationNode: 'Validation node',
  ValidationType: 'Validation type',
  ValidationMode: 'Validation mode',
  EmailAddress: 'Email address',
  Add: 'Add',
  Refresh: 'Refresh',
  ValidationRules: 'Validation rules',
  AllowOperationAfterValidationFails: 'Allow to continue operation after validation fails?',
  Yes: 'Yes',
  No: 'No',
  Company: 'Company',
  ContinueValidation: 'Continue validation',
  CurrentlyYouSureYouRefresh: 'Currently in edit mode, are you sure you want to refresh?',
  FailedToInitializeData: 'Failed to initialize data',
  AreRuleAssociatedValidationDeleted: 'Are you sure you want to delete this validation rule? Associated validation expressions and validation conditions will also be deleted!',
  PleaseSelectTheBranchOffice: 'Please select the branch office',
  PleaseEnterTheRuleName: 'Please enter the rule name',
  PleaseSelectTheRuleNode: 'Please select the rule node',
  PleaseSelectTheRuleType: 'Please select the rule type',
  PleaseSelectTheRuleMode: 'Please select the rule mode',
  CompanyName: 'Company name',
  PleaseConfigurationNameOrRemarks: 'Please enter the configuration name or remarks',
  Type: 'Type',
  InterfaceSettings: 'Interface settings',
  ConfigurationName: 'Configuration name',
  DefaultValue: 'Default value',
  EditConfigurationItem: 'Edit configuration item',
  EditConfigurationDefinition: 'Edit configuration definition:',
  Search: 'Search',
  ConfigurationItemconfigId: 'Configuration item (configId)',
  TypedataType: 'Type (dataType)',
  InterfaceSettingsisClient: 'Interface settings (isClient)',
  BranchOfficeOptionisOfficeOption: 'Branch office option (isOfficeOption)',
  ServiceSettingsisServer: 'Service settings (isServer)',
  OptionalItemliterals: 'Optional item (literals)',
  ConfigurationNamename: 'Configuration name (name)',
  Remarksremarks: 'Remarks (remarks)',
  DefaultValuevalue: 'Default value (value)',
  ConfigurationNameCannotBeEmpty: 'Configuration name cannot be empty',
  DefaultValueCannotBeEmpty: 'Default value cannot be empty',
  PleaseEnterTheBranchOffice: 'Please enter the branch office',
  Value: 'Value',
  ConfigurationItem: 'Configuration item',
  BranchOffice: 'Branch office',
  PleaseSelectAConfigurationDefinition: 'Please select a configuration definition',
  BranchOfficeCannotBeEmpty: 'Branch office cannot be empty!',
  ValueCannotBeEmpty: 'Value cannot be empty!',
  TheConfigurationAlreadyExistsCheck: 'The same branch office configuration already exists, please check',
  ApplyHeadOfficeSettings: 'Apply head office settings',
  SleepingDays: 'Sleeping days',
  SigningDays: 'Signing days',
  NotificationObject: 'Notification object:',
  Supervisor: 'Supervisor',
  NotificationMethod: 'Notification method:',
  InternalReminder: 'Internal reminder',
  HowDaysBeforeExpirationNotice: 'How many days before expiration notice:',
  Days: 'Days',
  DayMaintenance: 'Day maintenance:',
  BusinessEntity: 'Business entity',
  SelectEntityConfigurationItem: 'Select entity configuration item',
  BranchOffice2: 'Branch office:',
  EntitySelection: 'Entity selection:',
  AffiliatedBranchOffice: 'Affiliated branch office',
  EntityCode: 'Entity code',
  EntityName: 'Entity name',
  FieldCode: 'Field code',
  FieldName: 'Field name',
  ValueType: 'Value Type',
  All: 'All',
  SelectBranch: 'Select Branch',
  Unused: 'Unused',
  Used: 'Used',
  Example8180ThisTicketOnlyDollars: 'Example: USD:355/Exchange Rate:6.8180/This ticket only accepts US dollars',
  Precautions: 'Precautions:',
  SavedEffectFromTheInvoice: 'Saved settings will take effect from the next invoice',
  EBeLessThanCharacters: 'E-ticket remarks must be less than 100 characters',
  PaperBeLessThanCharacters: 'Paper ticket remarks must be less than 200 characters',
  AutomaticallyALineDoesShow: 'Automatically wrap when a line does not show',
  PDFCanDisplayUpLines: 'PDF format invoice remark column can display up to three lines',
  SerialNumber: 'Serial Number',
  ExternalFileType: 'External File Type',
  NecessaryScenario: 'Necessary Scenario',
  OriginalScenario: 'Original Scenario',
  TypePermission: 'Type Permission',
  AllPositions: 'All Positions',
  Client: 'Client',
  Shipper: 'Shipper',
  Consignee: 'Consignee',
  OverseasAgent: 'Overseas Agent',
  BookingAgent: 'Booking Agent',
  ExternalAccess: 'External Access',
  B2BCustomer: 'B2B Customer',
  B2BDesignatedCargoAgent: 'B2B Designated Cargo Agent',
  B2BDestinationPortAgent: 'B2B Destination Port Agent',
  B2BConsignee: 'B2B Consignee',
  TemplateOutputName: 'Template Output Name',
  Delimiter: 'Delimiter',
  NoteTemplateNameAccordingNeeds: 'Note: Please define the export template name according to your needs',
  DefaultSync: 'Default Sync',
  UsedFileAutomaticallySynchronizesBusiness: 'Used for setting whether this type of file automatically synchronizes between export and import business',
  CustomTemplateName: 'Custom Template Name',
  TemplateName: 'Template Name',
  Underscore_: 'Underscore _',
  Hyphen: 'Hyphen -',
  CreateFileClassification: 'Create File Classification',
  CreateFileType: 'Create File Type',
  Create: 'Create',
  Modify: 'Modify',
  FileClassification: 'File Classification',
  CurrentOperationStatusIsAbnormal: 'Current operation status is abnormal!',
  PleaseSelectChineseName: 'Please select Chinese name',
  CurrentOperatingStatusAbnormal: 'Current operating status abnormal',
  CondAlreadyExists: 'cond already exists',
  EDIFileDefaultTypeDefaultFileType: 'EDI File Default Type(DefaultFileType)',
  Emailemail: 'Email (email)',
  EDIFileEncodingTypeEncodingType: 'EDI File Encoding Type(EncodingType)',
  EDIFileCombinationMethodFileCombineType: 'EDI File Combination Method(FileCombineType)',
  PartnerCodeParnterId: 'Partner Code (ParnterId)',
  SendFTPFileNamePrefixsendFilePrefix: 'Send FTP file name prefix(sendFilePrefix)',
  SendFTPAddressTypesendType: 'Send FTP address type(sendType)',
  ServiceTypeServiceType: 'Service Type (ServiceType)',
  TemplateDescriptionTemplateDescribe: 'Template Description (TemplateDescribe)',
  TemplateAccessPathTemplatePath: 'Template Access Path (TemplatePath)',
  TemplateTypeTemplateType: 'Template Type (TemplateType)',
  ShutNoticeShutOutIdentification: 'Shut-out notice (Shut-out identification)',
  EDITemplateMaintenance: 'EDI Template Maintenance',
  PleaseEDIFileCombinationMethod: 'Please enter EDI file combination method',
  EDIMethodMustBeType: 'EDI file combination method must be numeric type',
  PleaseEnterPartnerCode: 'Please enter partner code',
  PartnerMustBeNumericType: 'Partner code must be numeric type',
  PleaseEnterServiceType: 'Please enter service type',
  ServiceMustBeNumericType: 'Service type must be numeric type',
  PleaseEnterTemplateDescription: 'Please enter template description',
  PleaseEnterTemplateAccessPath: 'Please enter template access path',
  PleaseEnterTemplateType: 'Please enter template type',
  TemplateMustBeNumericType: 'Template type must be numeric type',
  ShutMustBeNumericType: 'Shut-out notice must be numeric type',
  CloudStorageID: 'Cloud Storage ID',
  TemplateFileCloudStorage: 'Template File Cloud Storage',
  PleaseTemplateYouWantEdit: 'Please select the template you want to edit!',
  PleaseTemplateYouWantDelete: 'Please select the template you want to delete!',
  ConfirmDeletionOfThisTemplate: 'Confirm deletion of this template?',
  TemplateDeletedSuccessfully: 'Template deleted successfully!',
  TemplateDeletionFailed: 'Template deletion failed!',
  BasicFailedPleaseTryAgain: 'Basic template update failed, please try again!',
  BasicTemplateUpdateSuccessful: 'Basic template update successful!',
  PleaseEnterKeywordsToSearch: 'Please enter keywords to search',
  EmailTemplateEditing: 'Email template editing',
  PushingLink: 'Pushing link',
  TextTemplate: 'Text Template',
  Reminder: 'Reminder',
  SendEmail: 'Send email:',
  OK: 'OK',
  BasicData: 'Basic Data',
  SystemEmail: 'System Email',
  PicturePictureMustNot10M: 'Picture upload failed, picture must not exceed 10M!',
  PleaseAddProductDescriptionHere: 'Please add product description here',
  PreSendingSupplementaryInvitationLink: 'Pre-stowage information sending supplementary invitation link',
  MarineMBLInvitationForProofreading: 'Marine Export MBL Invitation for Proofreading',
  MarineHBLInvitationForProofreading: 'Marine Export HBL Invitation for Proofreading',
  MarineExportBulkPrinting: 'Marine Export Bulk Printing',
  AirCargoStorage: 'Air Cargo Storage',
  BillOfLadingPrintProduction: 'Bill of Lading Print Production',
  FileHistory: 'File History',
  InvoicePush: 'Invoice push',
  OceanShippingAlertReminderEmail: 'Ocean Shipping - Alert Reminder Email',
  ReminderEmail: 'Reminder Email',
  AirExportAlertReminderEmail: 'Air Export - Alert Reminder Email',
  RailwayAlertReminderEmail: 'Railway - Alert Reminder Email',
  AirImportAlertReminderEmails: 'Air Import - Alert Reminder Emails',
  IntegratedAlertReminderEmails: 'Integrated - Alert Reminder Emails',
  BookingPageData: 'Booking page data',
  ContentTemplate: 'Content Template',
  Updater: 'Updater',
  LastUpdateTime: 'Last Update Time',
  UploadedBeLargerThan20MB: 'Uploaded pictures cannot be larger than 20MB',
  PictureInsertionFailed: 'Picture insertion failed',
  OnlyVieweditOneEmailTemplate: 'Only allowed to view/edit one email template',
  CompanyEmail: 'Company Email',
  PersonalEmail: 'Personal Email',
  SentSuccessfully: 'Sent successfully!',
  ConfirmTheModifiedContent: 'Confirm the modified content?',
  ConfirmCancelingTheFilledmodifiedContent: 'Confirm canceling the filled/modified content?',
  PleaseInTheRecipientsEmail: 'Please fill in the recipient\'s email!',
  MappingType: 'Mapping Type',
  Description: 'Description',
  Condition: 'Condition',
  SendingPlatform: 'Sending Platform',
  EnglishName2: 'English Name',
  ChineseName2: 'Chinese Name',
  OriginalValue: 'Original Value',
  NewValue: 'New Value',
  EditMapping: 'Edit Mapping',
  CreateMapping: 'Create Mapping',
  PleaseEnterMappingType: 'Please enter mapping type',
  PleaseEnterTheOriginalValue: 'Please enter the original value',
  PleaseEnterTheNewValue: 'Please enter the new value',
  Branch: 'Branch',
  EnableAutomaticPush: 'Enable Automatic Push',
  SOPPushChannel: 'SOP Push Channel:',
  PushOnlyAfterConfirmingRecipient: 'Push SOP Status only after confirming SOP recipient:',
  PleaseSendersEmailWhichEmails: 'Please tick the box below to set the sender\'s email, which can be used when sending emails.',
  Username2: 'Username:',
  EmailPasswordauthorizationCode: 'Email password/authorization code:',
  EmailDisplayName: 'Email display name:',
  SenderServer: 'Sender server:',
  Port: 'Port:',
  WhenActualSenderIsEmail: 'When choosing a personal email, the actual sender is each user\'s registered email.',
  CompanyEnglishAbbreviation: 'Company English abbreviation:',
  BasicConfiguration: 'Basic configuration',
  SMS: 'SMS',
  Open: 'Open',
  Close: 'Close',
  EmailConfiguration: 'Email configuration',
  Signature: 'Signature:',
  EnableSignature: 'Enable signature',
  SMSConfiguration: 'SMS configuration',
  PleaseAProductDescriptionHere: 'Please add a product description here',
  CompanyAbbreviationCannotBeEmpty: 'Company Chinese abbreviation cannot be empty!',
  CompanyUsernameCannotBeEmpty: 'Company email username cannot be empty!',
  CompanyCodeCannotBeEmpty: 'Company email password/authorization code cannot be empty!',
  CompanyServerCannotBeEmpty: 'Company email sender server cannot be empty!',
  CompanyNumberMustBeNumber: 'Company email port number must be a number!',
  PersonalUsernameCannotBeEmpty: 'Personal email username cannot be empty!',
  PersonalServerCannotBeEmpty: 'Personal email sender server cannot be empty!',
  PersonalNumberMustBeNumber: 'Personal email port number must be a number!',
  AdditionalOutputAssociatedTemplate: 'Additional output associated template',
  TemplateEngine: 'Template engine',
  FilterScript: 'Filter script',
  BranchSerialNumber: 'Branch serial number',
  TemplateFile: 'Template file',
  TemplateClass: 'Template class',
  TemplateUsage: 'Template usage',
  Print: 'Print',
  CreateTemplate: 'Create template',
  TemplateFileCloudStorageID: 'Template file cloud storage ID',
  TemplateSerialNumber: 'Template serial number',
  SchemaTypeNotMaintained: 'SchemaType not maintained',
  CannotCheckWhetherTheCorrect: 'Cannot query basic template information, please check whether the template data source is correct!',
  SchemaTypeCannotBeEmpty: 'Schema Type cannot be empty.',
  TemplateTypeCannotBeEmpty: 'Template Type cannot be empty',
  TemplateDescCannotBeEmpty: 'Template Type Desc cannot be empty',
  ChineseNameLengthExceeds20: 'Chinese name length exceeds 20!',
  PleaseSelectStatusType: 'Please select status type!',
  PleaseSelectATriggerType: 'Please select a trigger type',
  DropThisConditionForGoods: '*Drop-down box is empty means not considering this condition. For example, not considering the type of goods',
  PushTarget: 'Push target',
  BookingSuccess: 'Booking success',
  WarehouseEntryNotification: 'Warehouse entry notification',
  BillOfLadingIssuance: 'Bill of lading issuance',
  DesignatedFreightAgent: 'Designated freight agent',
  DesignatedPostAndDesignatedPersonnel: 'Designated post and designated personnel',
  PleaseSelectDataFirst: 'Please select data first',
  AreToDeleteTheRecord: 'Are you sure to delete the selected record?',
  Hint: 'Hint',
  PleaseEnterTestEmailAddress: 'Please enter test email address!',
  PleaseEnterTestMobileNumber: 'Please enter test mobile number!',
  MobileOnlyBeANumber: 'Mobile number can only be a valid number!',
  MobileNumberFormatError: 'Mobile number format error!',
  SendingSuccessful: 'Sending successful!',
  SendingFailed: 'Sending failed!',
  ChineseName3: 'Chinese name',
  EnglishName3: 'English name',
  PublicOrNot: 'Public or not',
  Remark: 'Remark',
  AutomaticTrigger: 'Automatic trigger',
  DoNotSendNotification: 'Do not send notification',
  DesignatedPost: 'Designated post',
  Documentary: 'Documentary',
  LineManager: 'Line manager',
  PleaseEnterChineseName: 'Please enter Chinese name',
  PleaseEnterEnglishName: 'Please enter English name',
  PleaseSelectTriggerType: 'Please select trigger type',
  PleaseSelectStatusType2: 'Please select status type',
  ThereSameCodePleaseEnter: 'There already exists the same code, please re-enter!',
  ThereSameChineseNameEnter: 'There already exists the same Chinese name, please re-enter!',
  ThereSameEnglishNameEnter: 'There already exists the same English name, please re-enter!',
  PleaseEnterFieldName: 'Please enter field name',
  PleaseEnterFieldEnglishName: 'Please enter field English name',
  AreToDeleteTheType: 'Are you sure to delete the trigger type?',
  AllCharts: 'All charts',
  BusinessCharts: 'Business charts',
  FinancialCharts: 'Financial charts',
  ControlMode: 'Control mode:',
  ReceivingOrder: 'Receiving order',
  Printing: 'Printing',
  BillOfLadingRelease: 'Bill of lading release',
  NoDeduction: 'No deduction',
  OnlyHBL: 'Only HBL',
  OnlyHBLDeductHBL: 'Only HBL deduct HBL',
  OnlyMBL: 'Only MBL',
  OnlyMBLDeductMBL: 'Only MBL deduct MBL',
  HBLAtTheSameTime: 'HBL & MBL at the same time',
  HBLAtTheSameTime2: ' HBL, MBL deducted at the same time',
  OnlyHBLWithoutDeductingMBL: ' Only deduct HBL without deducting MBL',
  DoHBLOnlyDeductMBL: 'Do not deduct HBL, only deduct MBL',
  DocumentCirculation: 'Document circulation',
  ApplyTheHeadOfficesSettings: 'Apply the head office\'s settings',
  ReminderMode: 'Reminder mode',
  LockingMode: 'Locking mode',
  WhenRemindersAndTheLocked: 'When the credit control exceeds, only send reminders, and the work order will not be locked',
  WhenOrderUntilItApproved: 'When the credit control exceeds, lock the work order until it is automatically unlocked or manually approved',
  NotificationReminder: 'Notification reminder:',
  LockingControl: 'Locking control:',
  Event: 'Event',
  IsLocked: 'Is Locked',
  ControlObject: 'Control Object',
  ControlMethod: 'Control Method',
  PrintTemplate: 'Print Template',
  Document: 'Document',
  EmailAndReminder: 'Email and Reminder',
  None: 'None',
  SaveAndLock: 'Save and Lock',
  CannotSave: 'Cannot Save',
  BusinessLocked: 'Business Locked',
  BusinessUnlocked: 'Business Unlocked',
  CreditControlExceed: 'Credit Control Exceed',
  CreditControlChange: 'Credit Control Change',
  AddCopyFormalBusiness: 'Add/Copy Formal Business',
  OperationSupervisor: 'Operation Supervisor',
  SalesSupervisor: 'Sales Supervisor',
  CreditControlSupervisor: 'Credit Control Supervisor',
  BusinessCustomerService: 'Business Customer Service',
  MBLTabPrint: 'MBL Tab Print',
  MBLSplitMergePrint: 'MBL Split/Merge Print',
  HBLOriginalPrint: 'HBL Original Print',
  HBLSplitMergeOriginalPrint: 'HBL Split/Merge Original Print',
  HBLTelexPrint: 'HBL Telex Print',
  HBLSplitMergeTelexPrint: 'HBL Split/Merge Telex Print',
  BookingTabPrint: 'Booking Tab Print',
  BasicTab: 'Basic Tab',
  MAWBTab: 'MAWB Tab',
  HAWBTab: 'HAWB Tab',
  BookingEDI: 'Booking EDI',
  BillOfLadingEDI: 'Bill of Lading EDI',
  ReturnOrder: 'Return Order',
  AbnormalStatus: 'Abnormal Status',
  User: 'User',
  IPAddress: 'IP Address',
  PleaseEnterTheIPAddress: 'Please enter the IP address.',
  IndicatesUnrestricted: 'Indicates unrestricted',
  IPAddressCannotBeEmpty: 'IP address cannot be empty',
  PleaseSelectAUser: 'Please select a user',
  ThisAlreadyAddedAnWhitelist: 'This user has already added an IP whitelist',
  ExistingSameIPAddress: 'Existing same IP address',
  PleaseSelectData: 'Please select data',
  BusinessType: '業務種別',
  BillOfLadingType: 'Bill of Lading Type',
  DesignatedShippingLine: 'Designated Shipping Line',
  Expression: 'Expression',
  Example: 'Example',
  LetterSuffix: 'Letter Suffix',
  LetterexcludingIAndO: 'Letter Suffix (excluding I and O)',
  NumberSuffix: 'Number Suffix',
  MasterBillExtension: 'Master Bill Extension',
  SuffixSeparator: 'Suffix Separator',
  Constant: 'Constant',
  AddRule: 'Add Rule',
  PleaseEnterRuleName: 'Please enter rule name',
  Reset: 'Reset',
  ServiceCodeMaintenance: 'Service Code Maintenance',
  BusinessTypelob: 'Business Type (lob)',
  CargoPickupType: 'Cargo Pickup Type',
  BranchCodeoffice: 'Branch Code (office)',
  Salesperson: 'Salesperson',
  NetCodenetCode: 'Net Code (netCode)',
  SalesDepartment: '営業部門',
  OperationsDepartment: 'Operations Department',
  OverseasWarehouseCodeFBAFC: 'Overseas Warehouse Code (FBA FC)',
  PortCodeport: 'Port Code (port)',
  DeliveryPlaceCodeport: 'Delivery Place Code (port)',
  PolCode: 'Departure Port Code(POL)',
  DeparturePortCode: 'Departure Port Code',
  DestinationPortCode: 'Destination Port Code',
  DeparturePortExchangeCode: 'Departure Port Exchange Code',
  DestinationPortExchangeCode: 'Destination Port Exchange Code',
  ServiceCode: 'Service Code',
  OverseasAgentCode: 'Overseas Agent Code',
  JobNumberjobNo: 'Job Number (jobNo)',
  ReceivableOrPayable: '未収未払金（RP）',
  Jobyear: 'job (year)',
  Yearyear: 'Year (year)',
  Length: 'Length',
  Jobmonth: 'job (month)',
  Monthmonth: 'Month (month)',
  Dateday: 'Date (day)',
  JobSequenceNumberjobSequence: 'Job Sequence Number (jobSequence)',
  RandomLetters: 'アルファベットランダム',
  SequenceNumbersequence: 'Sequence Number (sequence)',
  CustomBusinessTypecustomJobType: 'Custom Business Type (customJobType)',
  SequenceNumberSettings: 'Sequence Number Settings',
  NeverResetN: 'Never Reset (N)',
  ResetByYearY: 'Reset by Year (Y)',
  ResetByMonthM: 'Reset by Month (M)',
  ResetByDayD: 'Reset by Day (D)',
  BusinessDate: '業務日付',
  DepartureDate: 'Departure Date',
  ShippingDate: 'Shipping Date',
  ArrivalDate: 'Arrival Date',
  BranchSequenceNumberIndependent: 'Branch Sequence Number Independent',
  CustomJobTypeSequenceNumberIndependent: 'Custom Job Type Sequence Number Independent',
  PaymentDirectionSerialNo: '収支方向シリアル番号は独立',
  DomesticBill: '国内請求書',
  DomesticBillNo: '国内請求書番号',
  ReceivableAndPayableio: 'Receivable and Payable (io)',
  BranchConfigurationIndependent: 'Branch Configuration Independent',
  JoiningDeclarationNumberRule: 'Joining Declaration Number Rule',
  TakeBillDateOnYearMonthDay: '年月日請求書受領日',
  TakeDocumentDateOnYearMonthDay: '年月日請求日',
  TakeActualPayDateOnYearMonthDay: '年月日は実際の支払期日を取る',
  UseBillDateOnYearMonthDay: '年、月、日付のフロー番号管理として、請求書の日付を使用します。',
  UseDocumentDateOnYearMonthDay: '年、月、日付のフロー番号管理として請求書作成日を使用します。',
  UseActualPayDateOnYearMonthDay: '実際の収支を年月日および流水番号制御として使用する。',
  DomesticStatement: '国内取引明細書',
  ForeignStatement: '海外取引明細書',
  AddConstant: 'Add Constant',
  PleaseToJobNumberSettings: 'Please refer to Job Number Settings',
  ConstantCannotBeEmpty: 'Constant cannot be empty',
  ConstantSpecialCharacters$: 'Constant cannot contain special characters $, {, }',
  ConfigurationCannotBeEmpty: 'Configuration cannot be empty!',
  LengthExceedsAllowableLength: 'Length exceeds allowable length!',
  ConfigurationExpressionCannotBeEmpty: 'Configuration expression cannot be empty',
  ThereAtLeastOneName: 'There must be at least one rule name',
  JoiningMustChooseAtItem: 'Joining declaration number rule must choose at least one item',
  ChangingInTheSystemModification: 'Changing configuration may affect the query of historical data in the system, do you want to save the modification?',
  RuleNameAlreadyExists: 'Rule name already exists',
  SaveFailed: 'Save failed',
  AreWantToDeleteRule: 'Are you sure you want to delete this rule?',
  Prompt: 'Prompt',
  BranchBankAccount: 'Branch Bank Account',
  SetAsDefaultRMBAccount: 'Set as Default RMB Account',
  SetAsDefaultUSDAccount: 'Set as Default USD Account',
  Currency: ' 通貨',
  Bank: 'Bank',
  Abbreviation: 'Abbreviation',
  AccountNumber: 'Account Number',
  RMBDefaultAccount: 'RMB Default Account',
  USDDefaultAccount: 'USD Default Account',
  BankChineseAddress: 'Bank Chinese Address',
  BankEnglishAddress: 'Bank English Address',
  TheItCannotBeAccount: 'The currency of this account is not RMB, it cannot be selected as the default RMB account.',
  TheItCannotBeAccount2: 'The currency of this account is not USD, it cannot be selected as the default USD account.',
  NameDoYouWantSave: ']Name already exists, do you want to save?',
  SaveWantToCloseWindow: 'Save successful, do you want to close the window?',
  CurrencyCannotBeEmpty: 'Currency cannot be empty',
  CodeCannotBeEmpty: 'Code cannot be empty',
  EnglishNameCannotBeEmpty: 'English name cannot be empty',
  AccountNumberCannotBeEmpty: 'Account number cannot be empty',
  TaxControlDiskNumberMaintenance: 'Tax Control Disk Number Maintenance',
  Number: 'Number',
  InvoiceCode: 'Invoice Code',
  UsageDepartment: 'Usage Department',
  TheNumberCannotBeRepeated: 'The number cannot be repeated!',
  InvoiceCodeCannotBeRepeated: 'Invoice Code cannot be repeated!',
  OneToMaintainMultipleNumbers: 'One department is not allowed to maintain multiple tax control disk numbers',
  NumberCannotBeEmpty: 'Number cannot be empty!',
  InvoiceCodeCannotBeEmpty: 'Invoice Code cannot be empty!',
  UsageDepartmentCannotBeEmpty: 'Usage Department cannot be empty!',
  DepartmentCode: 'Department code',
  JobNumberEncodingField: 'Job number encoding field',
  IsItASettlementCompany: 'Is it a settlement company',
  AddDepartment: 'Add department',
  TheOfTheDepartmentEmpty: 'The Chinese or English name of the department cannot be empty',
  EnabledSuccessfully: 'Enabled successfully!',
  DisabledSuccessfully: 'Disabled successfully!',
  SaveSuccessfully: 'Save successfully!',
  CompanyCode: 'Company code',
  BranchChineseName: 'Branch Chinese name',
  ChineseAddress: 'Chinese address',
  BranchEnglishName: 'Branch English name',
  City: 'City',
  PostalCode: 'Postal code',
  Fax: 'Fax',
  Phone: 'Phone',
  LocalCurrency: 'Local currency',
  DefaultAirport: 'Default airport',
  DefaultSeaport: 'Default seaport',
  SeaBillOfLadingAddress: 'Sea bill of lading address',
  AirBillOfLadingAddress: 'Air bill of lading address',
  RMBAccount: 'RMB account',
  USDAccount: 'USD account',
  OverseasBillAddress: 'Overseas bill address',
  DomesticBillAddress: 'Domestic bill address',
  OverseasEDICode: 'Overseas EDI code',
  MarkupTaxRate: 'Markup tax rate',
  InvoiceTaxRate: 'Invoice tax rate',
  SettlementEmail: 'Settlement email',
  TaxSystemInterfaceAddress: 'Tax system interface address',
  TaxControlPanelNumber: 'Tax control panel number',
  InvoiceTitle: 'Invoice title',
  InvoiceAddress: 'Invoice address',
  TaxpayerIdentificationNumber: 'Taxpayer identification number',
  ElectronicTicketPlatformCode: 'Electronic ticket platform code',
  ElectronicTicketPassword: 'Electronic ticket password',
  ElectronicTaxpayerIdentificationNumber: 'Electronic taxpayer identification number',
  ElectronicTaxpayerAuthorizationCode: 'Electronic taxpayer authorization code',
  ElectronicTicketServiceRequestAddress: 'Electronic ticket service request address',
  InvoiceCancellationRequestAddress: 'Invoice cancellation request address',
  RelatedPartners: 'Related partners',
  EFreighAMSAccount: 'E-Freigh(AMS account)',
  EFreighACIAccount: 'E-Freigh(ACI account)',
  CopyCompany: 'Copy company',
  AddBranch: 'Add branch',
  CopyBranch: 'Copy branch',
  BankAccount: 'Bank account',
  SelectFile: 'Select file',
  RemoveFile: 'Remove file',
  NewBranchInformation: 'New branch information',
  N1DepartmentsAndPositionBranch: '1. Permission management in all departments and position permissions of the branch',
  N2ParameterConfiguration: '2. Parameter configuration',
  N3OrderNumberConfiguration: '3. Order number configuration',
  Preview: 'Preview',
  Apply: 'Apply',
  CompanyCodeCannotBeEmpty2: 'Company code cannot be empty.',
  TheOfTheCompanyEmpty: 'The Chinese or English name of the company cannot be empty.',
  LocalNotAllowedToEmpty: 'Local currency is not allowed to be empty.',
  CopyCompanySucceeded: 'Copy company succeeded',
  AreYouSureToDelete: 'Are you sure to delete?',
  DeletedSuccessfully: 'Deleted successfully.',
  NameCannotBeEmpty: 'Name cannot be empty',
  SubmitSuccessfully: 'Submit successfully',
  RoleName: 'Role name',
  PleaseSelect: 'Please select',
  Individual: 'Individual',
  DepartmentGroup: 'Department group',
  BatchAddRolePermissions: 'Batch add role permissions',
  UpdatePermissionGroup: 'Update permission group',
  Removegtgt: 'Remove&gt;&gt;',
  ltltAdd: '&lt;&lt;Add',
  PermissionName: 'Permission name',
  PermissionClass: 'Permission class',
  PermissionType: 'Permission type',
  PermissionPoint: 'Permission point',
  Error: 'Error',
  AreDeleteTheCurrentlyRoles: 'Are you sure to delete the currently selected ',
  PleaseOrMoreRolesDelete: 'Please select one or more roles to delete!',
  PleaseOneOrMoreRoles: 'Please select one or more roles',
  PleaseOneOrMorePermissions: 'Please select one or more permissions',
  BatchAddSuccessfully: 'Batch add successfully',
  PleaseEnterTheRoleName: 'Please enter the role name',
  Meaning: 'Meaning',
  PleaseEnterTheServiceCode: 'Please enter the service code',
  PleaseTheServiceCodeMeaning: 'Please enter the service code meaning',
  Defaulted: 'Defaulted',
  SetAsDefault: 'Set as default',
  SuccessSetting: 'Success setting',
  AreToDeleteThisCode: 'Are you sure to delete this service code',
  SelectCustomer: 'Select customer',
  PleaseCodeEnglishNameName: 'Please enter acronym, code, English name, Chinese name',
  PleaseSelectACustomer: 'Please select a customer.',
  DataCargoTrackingPurchaseEffect: 'Data push service items: Port ship schedule, port cargo data, shipping company cargo tracking. Purchase data push service and configure this page to take effect',
  PushFCLLCLType: 'Push FCL/LCL type',
  PleaseSelectFCLLCLType: 'Please select FCL/LCL type',
  DoServicesNeedToVoyage: 'Do port ship schedule data push services need to update ship name and voyage',
  IsTrackingLimitedToDeparture: 'Is shipping company cargo tracking limited to port of departure',
  EnterpriseType: 'Enterprise type',
  SelectServiceEnabledSelectEffect: 'Select All to set all customers to open push service; select White List for customers who have push service enabled; select Black List for customers who have push service disabled, only the last saved setting will take effect.',
  WhiteList: 'White List',
  BlackList: 'Black List',
  DeleteConfiguration: 'Delete configuration',
  PushCondition: 'Push condition',
  DataSettings: 'データ設定',
  SynchronizationLogicSettings: '同期論理設定',
  ClearSettings: '設定をクリア',
  unBerthPlanDateSynETD: '計画離泊時間同期ETD',
  estimatedArrivalTimeSynETA: '到着予定時刻同期ETA',
  ClearVoyageAndShipPeriodData: '船舶名を空にする航空便の空にする船期データを修正する',
  MorePushConfiguration: 'More push configuration...',
  PortPortOfDepartureRange: 'Port data push port of departure range',
  Shanghai: 'Shanghai',
  Ningbo: 'Ningbo',
  Xiamen: 'Xiamen',
  Shenzhen: 'Shenzhen',
  Qingdao: 'Qingdao',
  Tianjin: 'Tianjin',
  Fuzhou: 'Fuzhou',
  Dalian: 'Dalian',
  NanSha: 'NanSha',
  CustomerList: 'Customer list',
  CloseOpen: '開通データサービス設定のクローズ',
  DataServiceSetting: 'データサービスの設定',
  DataServiceNotUpdateValue: 'データサービスはこのフィールド値を更新しません',
  ConditionType: 'Condition type',
  PleaseSelectConsignor: '委託先を選択してください',
  SubscriptionScope: '購読範囲',
  Consignor: 'Consignor',
  NoConfigurationItemsMade: 'No configuration items made.',
  DeletedSuccessfully2: 'Deleted successfully!',
  FCLLCLTypeNotSelected: 'FCL/LCL type not selected',
  PleaseSelectWhiteListCustomers: 'Please select white list customers',
  PleaseSelectBlackListCustomers: 'Please select black list customers',
  SavedSuccessfully: 'Saved successfully!',
  PleaseLeastOneDataDeletion: 'Please select at least one data for deletion!',
  PushServiceProviderConfiguration: 'Push service provider configuration',
  PushServiceName: 'Push service name',
  ServiceProviders: 'Service Providers',
  ShanghaiPort: 'Shanghai Port',
  ShippingCompanyCargoTracking: 'Shipping company cargo tracking',
  Seabourne: 'Seabourne',
  FreighTower: 'Freigh Tower',
  AirCargoTracking: 'Air cargo tracking',
  MaritimeDataPush: 'Maritime Data Push',
  AirFreightDataPush: 'Air Freight Data Push',
  YundangNet: 'YundangNet',
  SeaButler: 'Sea Butler',
  NingboPort: 'Ningbo Port',
  XiamenPort: 'Xiamen Port',
  QingdaoPort: 'Qingdao Port',
  FuzhouPort: 'Fuzhou Port',
  PortShipSchedule: 'Port ship schedule',
  ShenzhenPort: 'Shenzhen Port',
  DalianPort: 'Dalian Port',
  TianjinPort: 'Tianjin Port',
  DataPushCustomerList: 'Data push customer list',
  CustomerWhitelist: 'Customer whitelist:',
  PushContent: 'Sea Push content',
  AirPushContent: 'Air Push content',
  PushContent: 'Push content',
  PortContainerData: 'Port container data',
  NoCustomerSelected: 'No customer selected.',
  UpdateSuccessful: 'Update successful',
  Seaport: 'Seaport,',
  Airport: 'Airport,',
  ChargeItem: 'Charge item,',
  Route: 'Route,',
  Network: 'Network,',
  Currency2: 'Currency,',
  ContainerType: 'Container type,',
  Packaging: 'Packaging,',
  BillOfLadingType2: 'Bill of lading type,',
  CargoType: 'Cargo type,',
  TradeTerms: 'Trade terms,',
  TransportTerms: 'Transport terms,',
  TradeMode: 'Trade mode,',
  AirFreightServiceItems: 'Air freight service items,',
  RelatedPort: 'Related port,',
  AirCargoBillMiscellaneous: 'Air cargo bill miscellaneous,',
  CustomerType: 'Customer type,',
  BillOfLadingMethod: 'Bill of lading method,',
  CustomBusinessType: 'Custom business type,',
  CirculatingDocumentType: 'Circulating document type',
  Initialize: 'Initialize',
  Success: 'Success',
  Failure: 'Failure',
  AddPort: 'Add port',
  PleaseSelectPort: 'Please select port',
  Operator: 'Operator',
  PleaseSelectPort2: 'Please select port!',
  PleaseSelectOperator: 'Please select an associated user!',
  TheAlreadyMaintainedThisInformation: 'The user has already maintained associated configurations',
  PleaseNameEmailEtcQuery: 'Please enter Chinese name, English name, email etc. for fuzzy query...',
  NetManagementCode: 'Net management code',
  AfterBeAbleToContinue: 'After setting as invalid, the user will not be able to log in to the system, continue?',
  Valid: 'Valid',
  Invalid: 'Invalid',
  PleaseEnterEmail: 'Please enter email',
  EditSuccess: 'Edit success',
  EmailDuplicate: 'Email duplicate!',
  UserAllowsInputLettersNumbers: 'User code only allows input letters and numbers.',
  Operator2: 'Operator:',
  PortCode: 'Port code',
  RelatedUser: 'Related user',
  BusinessMode: 'Business mode',
  PleaseDataYouWantDelete: 'Please select the data you want to delete.',
  AreYouWantToDelete2: 'Are you sure you want to batch delete the {0} selected configuration items?',
  DeleteSuccess2: 'Delete success.',
  AddRoleUser: 'Add role user',
  AddUserWithUnassignedRole: 'Add user with unassigned role',
  Query: 'Query',
  SelectDepartment: 'Select department',
  AreYouWantToDelete3: 'Are you sure you want to delete?',
  SelectedUsersAlreadyExist: 'Selected users already exist',
  AddSuccessfully: 'Add successfully',
  CopyRole: 'Copy role',
  PasteRole: 'Paste role',
  PleaseRoleYouWantCopy: 'Please select the role you want to copy!',
  PleaseYouWantToRole: 'Please select the department where you want to paste the role!',
  IPWhitelist: 'IP whitelist',
  UserWhitelist: 'User whitelist',
  JobNumber: 'Job number',
  NoteMainAndSplit19: 'Note: The job number is up to 21 characters long, with the last two reserved for the main and split order signs, so the order number length set on this page must not exceed 19.',
  MainOrderNumber: 'Main order number',
  NoteNumberIsUpLong: 'Note: The bill of lading serial number is up to 16 characters long.',
  SubOrderNumber: 'Sub-order number',
  NoteIsUpToLong: 'Note: The sub-order number is up to 21 characters long.',
  WarehouseEntryNumber: 'Warehouse entry number',
  BookingNumber: 'Booking number',
  NoteYouHaveSelectedLength: 'Note: The warehouse entry number is up to 21 characters long, if you have selected the job number, please pay attention to its actual length.',
  OverseasBillNumber: 'Overseas bill number',
  NoteIsUpToLong2: 'Note: The overseas bill number is up to 16 characters long.',
  PaymentApplicationForm: 'Payment application form',
  PaymentApprovalForm: 'Payment approval form',
  NoteIsUpToLong3: 'Note: The payment application number is up to 16 characters long.',
  NoteIsUpToLong4: '説明：国内帳票番号は最長16桁。',
  BillOfLadingSerialNumber: 'Bill of lading serial number',
  SeaFreightExport: 'Sea freight export',
  SeaFreightImport: 'Sea freight import',
  AirFreightExport: 'Air freight export',
  AirFreightImport: 'Air freight import',
  FBASeaFreight: 'FBA sea freight',
  FBAAirFreight: 'FBA air freight',
  ReportName: 'Report name',
  Report: 'Report',
  PermissionAddedSuccessfully: 'Permission added successfully',
  PleaseReportLinkedToRole: 'Please select the report linked to the role',
  AreToDeleteTheRole: 'Are you sure you want to delete the currently selected role?',
  PermissionDeletedSuccessfully: 'Permission deleted successfully',
  QuickSearchAdTheme: 'Quick search: Ad theme',
  AdCode: 'Ad code',
  AdThemename: 'Ad theme/name',
  AdLocation: 'Ad location',
  BelongsToPage: 'Belongs to page',
  BelongsToModule: 'Belongs to module',
  BelongingSystem: 'Belonging system',
  PageViews: 'Page views',
  Clicks: 'Clicks',
  ClickRate: 'Click rate',
  NumberOfClickUsers: 'Number of click users',
  N0FileTypeNotSelected: '{0} File type not selected.',
  NoteCopyFollowingInformation: 'Note: You have chosen to copy [{0}], which includes the following information:',
  NXRoles: ' roles?',
  BranchSelection: 'Branch selection',
  CheckParentCompanyWithSubsidiary: 'Check the parent company and select the subsidiary company',
  CurrentlySelectedProject: 'Currently selected project:',
  AlertContentConfiguration: 'Alert Content Configuration',
  AlertTimeConfiguration: 'Alert Time Configuration',
  SopTimeSetUp: 'SOP Time Set Up',
  SetPersonalEmail: 'Please set personal email information',
  SetPersonalEmailNote1: "After setting up a personal email, the actual sending email is each user's personal email. Please ensure that each user sets up their personal email correctly.",
  SetPersonalEmailNote2: 'If not set correctly, use the company email and system email as the sending email in sequence.',
  SetPersonalEmailStep1: 'Step 1: Enter Settings and Tools, Personal Email Settings.',
  SetPersonalEmailStep2: 'Step 2: Maintain personal email password/authorization code, sending server, port, and signature information.',
  SetPersonalEmailStep3: 'Step 3: After saving, you can use your personal email as your outgoing email.',
  WhtTax: 'WHT tax',
  WhtTaxTip: 'Thailand and other scenarios containing WHT are applicable. After activation, expenses can be recorded and WHT tax can be deducted for account cancellation.',
  SendDestinationPortProxyDocuments: 'File History - Send destination port proxy documents',
  MainTicketAttachmentItem: 'Main ticket attachment item',
  SmallTicketAttachmentItem: 'Small ticket attachment item',
  SelectFileType: 'Select File Type',
  IncludeSlaveAttachLabel: 'When sending an email with the main ticket, the attachment must include a small ticket file',
  AutoGenerationManifestLabel: 'When there is no MANIFEST file in the main ticket, it is automatically printed according to the box number',
  FileAttachmentTip: 'If you need to verify the existence of attachments when sending them, please set them in the Basic Configuration - Verification Rule Configuration section.',
  FileAttachmentTip2: 'The system automatically matches the corresponding file attachments based on the HBL bill of lading method by default, which can be closed in Basic Configuration Configuration Management.',
  YearMonthEtdTip: 'If both job (year) and job (month) need to be checked, the value will be based on the month and month selected in the [sailing date]',
  YearMonthEtaTip: 'If both job (year) and job (month) need to be checked, the value will be based on the month and month selected in the [arrival date]',
  RiYearMonthEtaTip: 'If both job (year) and job (month) need to be checked, the value will be based on the month and month selected in the [arrival Date]',
  NotifySuperiors: 'Notify superiors',
  NotifySuperiorsCheckTip: "When selecting 'Notify Superior Supervisor', at least one 'Designated Position' must be selected!",
  AddOnlyCurrentTemplate: 'Add only to the current template',
  AddOtherSameLobTempalte: 'Add to other templates under the same business type',
  OnlyModifyCurrentTemplate: 'Only modify the current template',
  ModifyTemplateContaneNode: 'Modify all templates containing this node',
  AddRanges: 'Add Ranges',
  ModifyRanges: 'Modify Ranges',
  ApplicationTemplate: 'Application template',
  SetNodeLimitTip: 'When setting up nodes, the 【Code】, 【Chinese Name】, and 【English Name】 of SOP nodes under the same business type must be consistent.',
  SelectSOPTemplateForNode: 'Select the SOP template for node application',
  ConfirmJoinSelectTemplate: 'Are you sure to add it to the selected SOP template?',
  AddTemplateSameNode: 'Add to all templates of the same node',
  ModifyTemplateContinNode: 'Modify all templates containing the status of this node',
  HblBlWayAttachLabel: 'According to the mode and type of bill of lading of the business, the corresponding HBL file is extracted',
  HblWithoutGenerateAttachLabel: 'Automatically prints HBL proofs when there is no HBL file',
  ConfirmedPrintHblLabel: 'When the HBL status is confirmed but not issued, the HBL proof is automatically printed',
  PleaseSetSlaveAttach: 'Please set the file type for the small ticket attachment item first!',
  QueryFileType: 'Query file type: ',
  HblCfmStateOriginDraftLabel: 'When the HBL status is not issued, the HBL sample is drawn from the attachment; when the HBL has been issued, the HBL copy is drawn from the attachment',
  BillOfLading: 'Bill of Lading',
  AssociatedRoutesAndPorts: 'Associated routes and ports',
  AirlineChineseName: 'Airline chinese name',
  PortEnglishName: 'Port english name',
  OperationPosition: 'Operation position',
  UserConfigDuplicate: '{0} employee already has configuration item data, please do not duplicate configuration.',
  ConfirmSaveModifiedInfo: 'Are you sure you want to save the modified information?',
  PleaseSelectARoute: 'Please select a route',
  AssociatedPermissions: 'Associated permissions',
  OptionalPositionsRoles: 'Optional responsible positions are limited to user roles',
  ResponsiblePosition: 'Responsible for the position',
  SelectResponsiblePosition: 'Please select the responsible position!',
  ConfigApplyRemoteBooking: 'Configure application for remote booking module',
  AssociatedWarehouseSupplier: 'Associated warehouse supplier',
  WarehouseNameCustomsBrokeDestinationAgent: 'Please select an associated configuration item (warehouse name, customs declaration, destination port agent)',
  RelatedCustomsBroker: 'Related customs broker',
  RelatedDestinationAgent: 'Related destination port agent',
  AssociatedWarehouseName: 'Associated warehouse name',
  PortCodeRepeat: '{0} has already been set up, please do not repeat it.',
  RegionCodeRepeat: '{0} route has already been set up, please do not repeat it.',
  DesignatedCargoControlRange: 'Designated cargo control range:',
  RangeOfSelfPickupControl: 'Range of self pickup control',
  WarningConfiguration: 'Warning configuration:',
  AccountsReceivableSettlementUnits: 'All accounts receivable settlement units',
  MailServer: 'mail server',
  MailServerConfigTip: 'まず【プッシュ設定サービス】で会社メールを設定し有効化する必要があります。',
  PushConfigServiceCompanyEmail: 'You need to first set up your company email and enable it in the Push Configuration Service',
  PushConfigServicePersonalEmail: "Please select a designated position or a designated person's personal email. Before using it, you need to configure your personal email and enable it",
  SelectSendEmail: 'Select the sending email',
  Assigner: 'assigner',
  DeletePrompt: 'Are you sure to delete this account? Have you informed Yundang that this account has been abolished?？',
  EditUser: 'Edit user',
  NewUser: 'New user',
  Password: 'Password',
  CustomerName: 'Customer Name',
  AccountMaintenance: 'Call interface account maintenance',
  Unmaintained: 'You cannot subscribe to port data without providing an account password. Please contact customer service.',
  PortNotNull: 'Port cannot be empty',
  CustomerNotNull: 'Customer name cannot be empty',
  AccountNumberNotNull: 'Account cannot be empty',
  PasswordNotNull: 'Password cannot be empty',
  CustomIdNotNull: 'CustomId cannot be empty',
  PartnerWarehouseCode: 'パートナー受入番号コード',
  PartnerWarehouseCodeTip: '業務文書の委託先単位、指定貨物代理、仕向港代理が入倉番号代を設定する場合、値の優先順位を設定することができます。',
  ConfigEmailForNode: 'Configure the email service method for this node',
  CheckRuleToAllBranch: 'Validation rules are effective for all subsidiaries',
  CustomDescription: 'Custom Description',
  OnlyPositiveFeePermission: 'No operation permissions. Only positive fees can be added.',
  MultipleTriggers: 'Multiple triggers',
  IsMultipleTriggers: 'IS multiple triggers',
  AllowTriggeringAgainValueChange: 'Allow triggering again when the field value changes',
  OnlyEntityCodeSupportTrigger: 'Only date and string type fields with entity codes: Job/AirExportJob/AirimportJob/IntegratedJob/SeaExportJob/SealportJob support multiple triggers. Please confirm with R&D first!',
  TriggerTypeChangePushMsg: 'Trigger type value change and push message again',
  CheckBaseLabel: 'Only push according to the contact person set in the business document.',
  PushExternalInterfaces: 'Push external interfaces',
  TriggerInternalEvent: 'Trigger internal event',
  TriggerTypeChangePushInterface: 'Trigger type value change and push interface again',
  XhqBillDataUpdate: 'Signal flag bill of lading data update',
  msdBillDataUpdate: 'MSD請求書データプッシュAPI',
  MsdApiLog: 'MSD APIログ',
  canPushPreConfiguration: '事前設定プッシュ可能',
  pushPreConfiguredInformation: '事前設定情報をプッシュ',
  pushMasterData: '現在のマスタービルに含まれる全情報を事前設定データとしてプッシュします。確認後、「確定」をクリックしてください',
  AgainPushTitleDisplay: 'The title of the email being pushed again will display the change in the trigger type value. Display for example: booking message [export vessel name and voyage] Originally: SITC → Now: LECANGS; Original: V.088W → Now: 0XSJXS',
  PleaseSelectOpBranch: 'Please select the operating branch!',
  OpOfficeChangeUpdateData: 'The operation branch has been modified. Do you want to update the corresponding position personnel?',
  WarehouseChangeUpdateData: 'The operation branch has been modified. Do you want to update the corresponding warehouse/customs broker/destination port agent?',
  ClassifyName: '分类名称',
  Sort: '順序付けです',
  ClassifyMsgNameEmpty: '分類名は必ず記入します',
  ClassifyMsgSortEmpty: '並べ替え必須です',
  ClassifyMsgNameRepeat: '分類名は重複不可です',
  ClassifyMsgSortRepeat: '順序番号は重複してはいけません。',
  ConfirmDeletionOfClassifyMsg: 'メッセージ分類を削除するかどうかを判定します。日中対応のバージョンは同時削除されます!',
  ClassifyMsgDeletedTips: 'メッセージ分類の下にメッセージ通知があり、削除することはできません!',
  MsgTitle: 'メッセージタイトルです。',
  Content: '本文です',
  ConfirmDeletionOfBellMsg: 'メッセージ通知を削除するかどうか確認しますか?日中対応のバージョンは同時削除されます!',
  BellMsgTitleEmpty: 'メッセージタイトルは必ず記入します',
  BellMsgCodeEmpty: 'コードは必須です',
  BellMsgContentEmpty: '本文は必ず記入します',
  BellMsgTitleRepeat: 'メッセージタイトルは重複不可です。',
  BellMsgCodeRepeat: 'コードは重複できません',
  BellMsgContentRepeat: '本文は重複不可です',
  Language: '言語です',
  Link: 'ジャンプアドレスです',
  LinkTip: 'ルーティングにジャンプしてメッセージに対応する操作インターフェースにジャンプして、記入する前に先に研究開発と確認してください!',
  BellSubscriptionTitle: 'メッセージサブスクリプション設定です',
  BellSubscriptionConf: 'メッセージ購読をお知らせします',
  BellSubscribed: '購読済みです',
  BellUnSubscribed: '未購読です',
  MessageConfig: 'メッセージ設定です',
  WoBaoIntelligentAssistant: 'ウォボのスマートアシスタントです',
  WoBaoSubscriptionTip: 'ウォボのスマートアシスタントが、購読した今日の未読メッセージをページ上でお知らせします。',
  AllMessage: 'すべてのニュースです',
  TodayUnReadMsg: '今日のメッセージは未読です',
  ViewHQMapping: 'View HQ mapping',
  BranchNotMatchNotOperate: 'Not belonging to the data of this branch, unable to operate',
  UsersAlertNotifyAfterUsingXX: 'Users can configure an alert notification after using XX%.',
  UsersAlertNotifyBeforeExpireDate: 'Users can configure an alert notification to be sent XX days before the expiration date.',
  UnloadingEortEnName: 'The English name of the unloading port',
  OriginPortEnName: 'The English name of the port of origin',
  MatchingCriteriaSelection: 'Matching criteria selection',
  PresetValueConfiguration: 'Preset value configuration',
  MatchingCriteriaSelectionTip: 'Used for matching in business documents, automatically filling in preset values when matching conditions are met.',
  PresetValueConfigurationTip: 'Sea freight exports are calculated based on the ETD for the number of days in advance of the date. Automatically compensate for weekends. When the number of days is 0, it means that the relevant dates will not be automatically calculated.',
  PleaseSelectDeparturePort: 'Please select the port of departure',
  PleaseSelectUnloadingPort: 'Please select the unloading port',
  PleaseSelectCarrier: 'Please select carrier',
  PortRequirementBillRequirements: 'Port requirements (bill of lading requirements)',
  PleaseSaveCurrentDataFirst: 'Please save the current data first',
  RelatedInstructionsAttachments: 'Related instructions and attachments',
  PortRequirementsRelatedDocuments: 'Port requirements related documents',
  NoRelevantDocumentsAvailable: 'No relevant documents available',
  DefaultConfigurationNotes: 'Default configuration notes',
  PleaseSelectMatchingItem: 'Please select a matching item',
  PleaseSetPreset: 'Please set a preset',
  CalculateDateIncludeETDTheDay: 'Calculation of lead time includes the day of ETD',
  SetLeadTimeBasedOnETDTime: 'Set lead time based on ETD time',
  WoBaoSubscribed: '開きました',
  WoBaoUnSubscribed: '閉鎖されました',
  CalculateIncludeEtdIsWeekend: 'The lead time calculation includes ETD on weekends',
  PositionAssociatedRoutePortConfig: 'Position personnel are associated with preset configurations of flight routes/ports',
  PleaseSelectLoadingPort: 'Please select the loading port',
  PleaseSelectOriginatingStation: 'Please select the originating station',
  PleaseSelectDestinationStation: 'Please select the destination station',
  PositionCannotDuplicated: 'The position cannot be duplicated',
  UserHasRepeatConfigData: 'The user already has duplicate configuration data!',
  UserRoleDefaultRepeat: 'Other employees have already configured the default position value for this matching criterion. Are you sure you want to modify it?',
  ChartSource: 'Chart source',
  EnterChartSource: 'Please enter the chart source',
  ToDoNodeRuleSettings: 'To do node rule settings',
  ServiceScenarioApplication: '特定業務ルールです',
  SettingApplicationScenarios: '業務ルールの設定です',
  MainNotToDoTask: 'The main ticket document is not considered a to-do task (LCL scenario)',
  SpecifyRole: 'Specify Role',
  CheckPrivilegePersonLabel: 'Do you want to restrict roles without type permissions from modifying file types',
  SetExclusionOffices: '免除支社の設置',
  AccountsReceivable: 'Accounts receivable',
  Just: 'Just',
  NotEntityCompany: '非エンティティ会社',
  NotEntityCompanyTip: '特定の財務諸表を集計する場合は、このIDをチェックする必要があります。',
  Marked: 'マーキング',
  NotSetDefaultValueMultiPosition: 'When the conditions match multiple job positions, the default values are not displayed and manual selection is required!',
  AvailableOfficeOverMaxLimit: 'Your available branch offices have reached the maximum limit. If it is necessary to increase the number of branch offices. You can contact your sales personnel or customer service.',
  AvailableUserOverMaxLimit: 'You have reached the maximum number of available users. If it is necessary to increase the number of users. You can contact your sales personnel or customer service.',
  BranchCountExpireLimitUse: 'Dear user, the extension branch you purchased has expired.<br>Please renew and continue using. You can contact your salesperson or customer service.<br><div style="margin-top: 5px;">The current branch office will be restricted from accessing and data will be retained. After renewal, it can be used again.</div>',
  UserCountExpireLimitUse: 'Dear user, the number of extended users you purchased has expired.<br>Please renew and continue using. You can contact your salesperson or customer service.<br><div style="margin-top: 5px;">The current user will be restricted to disabled and data will be retained. After renewal, it can be reactivated for use.</div>',
  UserCountExpireLimitAdmin: 'Dear user, the number of extended users you purchased has expired.<br>Please renew and continue using. You can contact your salesperson or customer service.<br><div style="margin-top: 5px;">The current user (excluding system administrators) will be restricted to disabled and data will be retained. After renewal, it can be reactivated for use.</div>',
  OpenConfig: 'Open Config',
  SendType: 'Send Type',
  Key: 'Key',
  UserPwd: 'User Pwd',
  OpenConfigTip: 'After activation, the template is sent according to the configured {0}',
  NotEmptyTips: 'The blue field is a required field!',
  MustBeNumericType: '{0}Must Be Numeric Type',
  MainTicket: 'Main ticket',
  SlaveTicket: 'Slave ticket',
  Alias: 'Alias',
  SetAlias: 'Set alias',
  AliasOnlyHQ: 'Set aliases uniformly only under HQ',
  HideCategoryAllLanguage: 'Hide this category (applies to all language versions)',
  FieldDisplayHideForbid: 'When there are fields with display status under the category, hiding is not allowed!',
  HQSavePrompt: 'HQ Save Prompt',
  BranchSavePrompt: 'Office Save Prompt',
  OnlyDisplayMandatoryRule: 'Only adjust the display of fields and mandatory rules, without covering the display order of fields on custom pages for branch offices and employees!',
  DisplayMandatorySort: 'Adjust the display of fields and mandatory rules, and reset the field display order of custom pages for subsidiaries and employees according to HQ rules!',
  AdjustOrderConfig: 'This item will adjust the order of the configured interfaces for all subsidiaries and employees to the setting order of HQ!',
  OfficeOnlyDisplayMandatoryRule: "Only adjust the display of fields and mandatory rules, without covering the display order of fields on employees' custom pages!",
  OfficeDisplayMandatorySort: "Adjust the display of fields and mandatory rules, and reset the field display order of employees' custom pages according to branch rules!",
  OfficeAdjustOrderConfig: 'This item will adjust the interface order that employees have already configured to the setting order of the branch company!',
  ApplyHQSetting: 'Are you sure to apply the headquarters settings?',
  ResetCustomSetConfirm: 'Are you sure to reset the custom settings for this tab? This operation is irreversible, please confirm!',
  HQSettingNotEditAlias: 'When applying HQ settings, branches cannot make edits or adjustments. Alias settings are uniformly configured under HQ only.',
  NonLoginUser: 'Non-logged in system user',
  ValidUserNotNeedLogin: 'Among valid users, users who do not need to log in to the system',
  NotLoginUserContactAdmin: 'The system administrator has set you as a user who does not require logging into the system. If you need to use the operating system, please contact your administrator to make adjustments and log in again.',
  FinanceExpireLimitUse: 'Dear user, the financial management module you purchased has expired.<br>Please renew and continue using. You can contact your salesperson or customer service.<br><div style="margin-top: 5px;">Please renew and continue using. You can contact your salesperson or customer service.</div>',
  EdiExpireLimitUse: 'Dear user, the EDI booking interface you purchased has expired.<br>Please renew and continue using. You can contact your salesperson or customer service.',
  TaxExpireLimitUse: 'Dear user, you have not activated the tax control service, or the tax control service you purchased has expired.<br>Please renew and continue using. You can contact your salesperson or customer service.',
  EntrustPageTab: 'Entrustment page tab',
  ExportEntrustPageTab: 'Export entrustment page tab',
  ImportEntrustPageTab: 'Import entrustment page tab',
  AttachmentRuleConfig: 'Attachment rule configuration',
  BusinessOrdersAttachments: 'When the business is divided into formal orders, attachments are extracted and divided into formal orders',
  SendPackageProxyFiles: 'File History - Send Package Proxy Files',
  BillNotStartNoneFile: 'When the HBL bill of lading status has not started or is pending confirmation, no bill of lading documents (including samples) will be extracted',
  LockAfterSend: 'Lock after sending:',
  SendLockSlaveHblAndVirtualBill: 'After sending, lock the HBL and form split tab of the receipt (including splitting/merging)',
  SendLockExchangeAgentHblAndVirtualBill: 'After sending, lock the HBL tab and form splitting tab (including splitting/merging) of the corresponding exchange agent',
  AutoPrintManifestAfterAllHblConfirm: 'Automatically print MAINFEST files (including HBL split orders) only after all HBL bill of lading statuses have been confirmed',
  BusinessDataNotUpdate: 'Do not automatically update job personnel when updating business data',
  AutoPrintRule: 'Automatic printing rule',
  EmailAttachRule: 'Rules for extracting email attachments',
  FormalDivisionRule: 'Formal division rules',
  BusinessIfVirtualBillOnlyAttachment: 'If a service has a formal sub-order, only the formal sub-order file is extracted from the attachment',
  SetFileSyncRule: 'Set file synchronization rules',
  BusinessModel: 'Business model:',
  SyncDirection: 'Synchronization direction:',
  SyncCondition: '同期条件',
  SyncFileToApprovedDoc: 'ファイルを承認済み書類に同期可能',
  DeleteFile: 'Delete file:',
  SyncMode: 'Synchronization mode:',
  CrossDelegation: 'Cross delegation',
  PrincipalOperator: 'Principal ->Operator',
  OperatorClient: 'Operator ->Client',
  SyncFileDeletion: 'Synchronize file deletion',
  NotDeleteRelateFile: "Do not delete the other party's files",
  ManualSync: 'Manual synchronization',
  AutoSync: 'Automatic synchronization',
  ExportToImport: 'Export to Import',
  ExporterImporter: 'Exporter ->Importer',
  ImporterExporter: 'Importer ->Exporter',
  BbSendDestinationPortAgent: 'パッケージング委託先港代理書類送付',
  ChargeSyncAuditPass: '料金同期-審査通過です',
  ChargeSyncAuditNotPass: '料金の同期-審査が通りません',
  ChargeSyncRecallApplyCharge: '料金同調-請求料の撤回です',
  SendEmailByPositionPersonnel: 'メールは送信元の設置担当者に送られます。',
  AttachmentItems: '添付項目',
  PleaseSetAttach: '添付ファイル項目のファイルタイプを設定してください！',
  SendLockHblAndVirtualBill: '送信後、ロックされたトラフィックのHBLとフォーム・ページング・サイン（解除/併合を含む）',
  AirOperationTAB: 'Air Operations TAB',
  CurrentPageNewFieldTip: 'There are new fields on the current TAB page. Click Edit to add fields.',
  SystemAddedItem: 'A field item is added to the system',
  DragTheBlockUse: 'Please drag and drop the field to the corresponding block to use it',
  CustomTemplateMustSelect: 'Custom template name must select one piece of information',
  VirtualBillHBLNO: 'Virtual Bill HB/L NO',
  TemplateRemarks: 'テンプレートコメント',
  AutomPrintDefaultFileType: 'デフォルトのファイルタイプを自動的に印刷する',
  PopupMode: 'ポップアップモード',
  DisplayWhenThereIsValidation: '検証中にエラーメッセージがある場合のみ、検証情報ポップアップを表示します。',
  TheBeAppliedToOffices: 'ポップアップモードはすべての支店に適用されます。',
  VerificationNodeCannotBeEmpty: '【検証ノード】は空にできません',
  VerificationModeCannotBeEmpty: '【検証モード】は空にできません。',
  CustomerOfLadingOptionIssue: '顧客自身による発行（船荷証券オプション：顧客自身による発行）',
  WhenLadingHasBeenDocuments: '顧客が自ら書類を提出し、船荷証券が確認または発行された場合、顧客の自提出書類を抽出します。',
  WhenIsNeitherConfirmedExtracted: '顧客が自ら船荷証券の書類を提出し、かつ船荷証券が確認も発行もされていない場合、顧客が自ら提出した船荷証券は抽出されません。',
  WhenOfLadingHasSample: '顧客発行の書類がなく、船荷証券が確認済みで未発行の場合、自動的に見本を印刷します。',
  ApplicationModule: 'アプリケーションモジュール',
  UICustomisation: 'UIカスタマイズ',
  SOPPanel: 'SOPパネル',
  InvokeAutomatedExecution: '自動実行を呼び出す',
  FileHistoryTab: 'ファイル履歴タブ',
  ViewOpInstruction: '操作手順を表示する',
  SetOpInstruction: '操作内容コマンドを設定する',
  HeadquartersSetupForCommandApplications: '指令アプリケーション本社の設置',
  SetCommandParameters: 'コマンドパラメータを設定する',
  DisplayRuleSettings: '表示ルール設定',
  PleaseCommandForAScenario: '指定されたシナリオの操作コマンドを設定してください。',
  CommandParameters: 'コマンドパラメータ',
  SceneRules: 'シーンルール',
  SceneParameters: 'シーンパラメータ',
  CommandApplication: 'コマンドアプリケーション',
  TheStatusOfAllProcesses: '業務に従って送信する際、すべてのHBL処理状況が確認された後で初めて、マニフェスト（分割注文を含む）が自動印刷されます。',
  WhenOnlyAfterTheConfirmed: 'コンテナで送付する場合、そのコンテナに該当するすべてのHBLの状態が確認された後で初めて、マニフェスト（分割注文を含む）が自動印刷されます。',
  TheLettersAndBeLength: 'パスワードは数字、小文字、大文字を含み、8〜20文字の長さである必要があります。',
  WhenIssuesBillOfExtracted: '顧客が荷物受領証（「顧客が荷物受領証を発行する」を選択）を発行する場合、顧客が発行した荷物受領証のみを抽出します。',
  SetBlockWidth: 'ブロックの幅を設定する',
  SettableRange300400: '設定可能な範囲：300〜400',
  CommandApplication: 'コマンドアプリケーション',
  TheStatusOfAllProcesses: '業務に従って送信する際、すべてのHBL処理状況が確認された後で初めて、マニフェスト（分割注文を含む）が自動印刷されます。',
  WhenOnlyAfterTheConfirmed: 'コンテナで送付する場合、そのコンテナに該当するすべてのHBLの状態が確認された後で初めて、マニフェスト（分割注文を含む）が自動印刷されます。',
  DisplaySettings: '表示設定',
  ApplicationSettings: 'アプリケーション設定',
  ReadAndWriteSettings: '読み書き設定',
  CanEditable: '編集可能',
  VisibleToDesignatedPersonnel: '指定された担当者のみ閲覧可能：',
  FieldPermissionSettings: 'フィールド権限設定',
  CanWrite: '書くことができる',
  FieldNameQuery: 'フィールド名クエリ',
  TheAsTheOceanConfiguration: '予約事前審査フィールドの別名は、海運予約設定と同じであり、個別設定はサポートされていません！',
  TheAsThoseForConfiguration: '海上輸送の予約委任のフィールドエイリアスは、海上輸送の予約設定と同じであり、独立した設定はサポートされていません！',
  TheAsTheAirConfiguration: '空運予約委託のフィールドエイリアスは、空運予約設定と同じであり、個別設定はサポートされていません！',
  TheThoseInTheConfiguration: '鉄道予約委任のフィールド別名は鉄道操作設定と同じであり、個別設定はサポートされていません！',
  TheOrderInTheConfiguration: '订单预審フィールドの別名は航空貨物予約設定と同じであり、独立した設定はサポートされていません！',
  FillInMode: '入力モード',
  SingleTicketBusinessForm: '単票業務の記入',
  BulkProcessing: '一括処理',
  SingleFormSubmission: '単一のフォーム入力',
  BatchFillOutForms: '一括でフォームを入力する',
  SelectionForm: '選択フォーム',
  TriggerNodeStatesupConfigured: '他のノードの状態をロールバックする（最大5つまで設定可能）',
  RollbackBeSetOnlyStartedAbnormal: '[状態タイプ]が[未着手]/[異常]のときのみ、他のノードの状態へのロールバックを設定できます。',
  PleaseNodeThatNeedsTriggered: 'トリガーが必要なロールバックノードを設定してください',
  TheNodeCannotBeEmpty: 'ノードは空にできません',
  TheStatusCannotBeEmpty: 'ノードの状態は空にできません',
  AllowStatusToTriggerRollback: 'ノードの状態がロールバックをトリガーすることを許可する',
  SOPRestrictionsForBusinessDocuments: '業務文書のSOPテンプレートマッチング制限',
  OnlyForTheBranchTemplate: '分社およびHQテンプレートに設定されたアプリケーション操作のみ',
  OnlyOperationDepartmentAndTemplate: '指定されたアプリケーション操作部門およびHQテンプレートのみ',
  TabSettings: 'タブ設定',
  StandardFeesTab: '標準費用タブ',
  HideStandardFeeTab: '標準手数料タブを非表示にする',
  DisplayAsASeparateTab: '別のタブとして表示',
  DropdownBoxValueDisplay: 'ドロップダウンボックスの値表示：',
  DisplayRecentlyUsed50Values: '最近に使用された上位50件のデータ値を表示する',
  DisplayOrderLogic: '表示順序の論理：',
  TheFirstValueTheSequentially: '最終に保存されたデータが最初の値として表示され、前回の保存データが2番目として表示され、順次表示されます。',
  InstructionPermissions: '指令権限',
  AllPositions2: 'すべての職位',
  PleaseAPositionOrPersonnel: 'ポジションまたは人員を選択してください',
  SalesModule: '販売モジュール',
  SalesInquiry: '販売照会',
  SalesInquiryApplication: '売上照会アプリケーション',
  SalesTheCustomTabUI: '販売照会機能により、このUIのカスタムタブを表示できます。',
  DisplayCargoPackingInformation: '積載貨物情報を表示する',
  ControlPropertyConfiguration: 'コントロール属性の設定',
  WhenMainTicketDisplayMode: '業務書類がメインチケットの場合、メインチケットの梱包モードを表示します。',
  UpdatePortDataButton: '港データ更新ボタン',
  UIFieldConfiguration: 'UIフィールド設定',
  AutomatedExecution: '自動実行',
  SOPStatusTrigger: 'SOP状態のトリガー',
  TriggerBasedOnFieldValue: 'フィールド値に基づいてトリガーする',
  DocumentInfo: 'ドキュメント情報',
  DocumentTemplate: 'ドキュメントテンプレート',
  LocalizedTemplateName: 'ローカライズされたテンプレート名',
  TemplateId: 'テンプレートID',
  TemplateStatus: 'テンプレートステータス',
  TemplateType: 'テンプレートタイプ',
  TemplateDescription: 'テンプレートの説明',
  LocalizedTemplateDescription: 'ローカライズされたテンプレートの説明',
  ApplicableCarrier: '該当運送会社',
  ApplicableSeaport: '該当港口',
  PleaseEnterLocalTemplateName: 'ローカルテンプレート名を入力してください',
  TemplateEnabledPrompt: '【{0}】 - 【{1}】ファイルは正常です。有効にすると、業務でユーザーが使用する可能性があります。',
  TemplateDisabledPrompt: '【{0}】 - 【{1}】を無効にすると、業務中にユーザーが検索または使用できなくなります。',
  TemplateDeletedPrompt: '【{0}】 - 【{1}】が削除されたかどうか確認してください。',
  TriggeredToSpecificBusinessRules: '特定の業務ルールに基づいてトリガーされる',
  InvoiceInquiryTab: '請求書照会タブ',
  SetFieldValueSynchronization: 'フィールド値の同期設定',
  SourceTab: 'ソースタブ',
  SourceField: 'ソースフィールド',
  WriteTab: '書き込みタブ',
  WriteField: 'フィールドへの書き込み',
  SyncOnlyAtCreation: '作成時のみ同期',
  SynchronizedReceiptWithMainTicket: 'メインチケットと同期したサブレシート',
  AreWantToDeleteData: '選択したデータを削除してもよろしいですか？',
  TheFieldCannotBeEmpty: '【{0}】フィールドは空にできません。',
  ConfirmFieldValueSynchronizationConfiguration: 'フィールド値の同期設定を保存しますか？',
  ShippingInformationNonMainInvoice: '梱包情報－メイン票以外',
  ConfirmBatchModification: '一括変更を確認しますか？',
  PleaseSelectFillModeAndForm: '入力モードを選択し、フォームを選択してください！',
  FillFormCannotBeEmpty: '入力フォームは空にできません！',
  BatchModificationPrompt: '一括変更プロンプト',
  ConfirmBatchModification: '一括変更を実行しますか？この操作により、選択されたすべてのタスクが一括変更されます。',
  BatchModificationConfirm: '一括変更の確認',
  TemplateApplicationSettings: 'テンプレート適用設定',
  MatchingSettings: 'マッチング設定',
  ManualSOPTemplatesIsAllowed: 'SOPテンプレートの手動置き換えは許可されていません。',
  DoTemplateIsAutomaticallyTemplate: 'テンプレートが新しいテンプレートに自動的にマッチしたときに、プロンプトを表示しない。',
  ContainerMaxNumTip: '箱量は【{0}】個を超えることができません。超える必要がある場合は、カスタマーサービスに連絡して【ContainerMaxNum】パラメータの閾値を調整してください。',
  BatchOperationSettings: '一括操作の設定',
  BatchOperationsSupported: '一括操作が可能です',
  BulkOperationPrompt: '一括操作のプロンプト',
  PleaseSelectRailwayExportServices: '鉄道輸出業務を選択してください',
  PleaseSelectRailwayImportBusiness: '鉄道輸入業務を選択してください',
  BatchAllowedPleaseSelectRecord: '一括操作はできません。単一のレコードを選択してください。',
  AreWantToPerformOperation: '一括操作を実行してもよろしいですか？',
  NonNotSupportCrossTenants: 'グループ会社でない場合、同一テナント間のクロス委任をサポートしていません。',
  NoBusinessCanBeEntrusted: '委任できる業務がありません。',
  PleaseSelect0: '{0}を選択してください',
  ShippingInformationMasterBill: '梱包情報 - マスタービル',
  HideDefaultButton: 'デフォルトボタンを非表示にする',
  AdditionalReceivables: '未収入金の追加',
  AdditionalPayable: '追加の未払金'
}
